import React, { useState, useContext, useCallback } from 'react';
import { Button } from '@mui/material';
import { MapContext } from '../MapContext';
import { LayerContext } from '../LayerContext';
import { loadFGB } from '../ROI/loadFeaturesFromFGB'

import { DownloadSgeButton, DownloadBoundaryButton } from '../Util/DownloadButton';

const RoiControls = ({ layer, layerVisibility }) => {
  const { map } = useContext(MapContext);
  const { dispatch } = useContext(LayerContext);

  const [color, setColor] = useState(layer.color);
  const [count, setCount] = useState(0);
  const [summary, setSummary] = useState({});

  const handleColorChange = (e) => {
    if (map && map.current) {
      map.current.setPaintProperty(layer.id, 'fill-color', e.target.value);
    }
    setColor(e.target.value);
  };
  const handleDownloadSGEClick = useCallback(async () => {
    const boundary = layer.boundary;
    const fgbSrc = layer.fgbSrc;  // Provide your fgb_srcs here
    const summary_ = await loadFGB(fgbSrc, boundary, setCount);  // Step 4: Call loadFGB
    setSummary(summary_);
    dispatch({
      type: 'CHANGE_LAYER',
      payload: {
        ...layer,
        ...summary_
      }
    });
  }, [layer.boundary]);

  return (
    <div>
      <div className='layerPanelControl'>
        <Button
          variant="outlined"
          size="small"
          color="primary"
          onClick={handleDownloadSGEClick}
          disabled={!layerVisibility}
        >
          Extract SGE
        </Button>
        <span>{count}</span>
      </div>
      <div className='layerPanelControl'>
        <DownloadBoundaryButton
          features={[layer.boundary]}
          fileName={'bd-' + layer.id}
          layerVisibility={layerVisibility}
        />
        <DownloadSgeButton
          features={summary.sge}
          fileName={'sge-' + layer.id}
          layerVisibility={layerVisibility}
        />
      </div>
      <div className='layerPanelControl'>
        <span>Color:</span>
        <input
          type="color"
          value={color}
          onChange={handleColorChange}
          disabled={!layerVisibility}
        />
      </div>
    </div>
  );
}

export default RoiControls;
